<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
  import { mapGetters } from 'vuex';
  import ListDefault from '@/components/invites/ListDefault';
  import ListOld from '@/components/invites/ListOld';
  import PROCESS_NAMES from '@/process/names';

  export default {
    name: 'InvitesListProcess',

    components: {
      ListDefault,
      ListOld
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      way() {
        if (this.getProcessName !== undefined) {
          if (
            this.getProcessName === PROCESS_NAMES.CITIBANK ||
            this.getProcessName === PROCESS_NAMES.CITIBANK_RYAZAN ||
            this.getProcessName === PROCESS_NAMES.CITIBANK_AMBASSADOR ||
            this.getProcessName === PROCESS_NAMES.SPORTMASTER
          ) {
            return 'list-old';
          }

          return 'list-default';
        }

        return 'list-default';
      }
    }
  };
</script>
